import { NgModule, DoBootstrap, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DecimalPipe, CurrencyPipe } from '@angular/common';
import { MedicationInformationComponent } from './medication-information/medication-information.component';
import { DoctorInformationComponent as DoctorInformationComponent_Wrapper} from './doctor-information/doctor-information.component';
import { DoctorInformationComponent as DoctorInformationComponent_SapphireDigital} from './doctor-information-sapphire-digital/doctor-information.component';
import { DoctorInformationComponent as DoctorInformationComponent_Kyruus} from './doctor-information-kyruus/doctor-information.component';
import { createCustomElement } from '@angular/elements';
import { PtlXhrModule } from '@ptl/xhr';
import { MaterialGlobalModule } from 'src/app/shared/modules/material-global.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgReduxFormConnectModule, NgReduxFormConnectArrayModule } from '@ptl/angular-redux-form';
import { NgReduxModule } from '@ptl/angular-redux-store';
import { TotalDrugCostComponent } from './total-drug-cost/total-drug-cost.component';
import { AutocompleteDrugFilter } from './medication-information/filters/autocompleteDrug.filter';
import { UniqueDoseDirective } from './medication-information/validators/unique-dose.directive';
import { YearlyDrugCostsGraphComponent } from './total-year-costs/graphs/yearly-drug-costs-graph/yearly-drug-costs-graph.component';
import { YearlyDrugCostsTableComponent } from './total-year-costs/table/yearly-drug-costs-table/yearly-drug-costs-table.component';
import { ToggleRadioComponent } from './retail-mail-toggle/toggle-radio/toggle-radio.component';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { ReducersRegistryModule } from 'src/app/shared/modules/reducers-registry.module';
import { PharmacyInformationComponent } from './pharmacy-information/pharmacy-information.component';
import { PharmacyDetailComponent } from './pharmacy-information/pharmacy-detail/pharmacy-detail.component';
import { IndividualMedInfoComponent } from './medication-information/individual-med-info/individual-med-info.component';
import { MemberDrugInformationComponent } from './member-drug-information/member-drug-information.component';
import { DoctorDetailComponent } from './doctor-information/doctor-detail/doctor-detail.component';
import { AddressFilterPipe } from './doctor-information-kyruus/filters/address-filter.pipe';
import { StateModuleReadyService } from '@ptl/state';

@NgModule({
  declarations: [
    AutocompleteDrugFilter,
    MedicationInformationComponent,
    DoctorInformationComponent_Wrapper,
    DoctorInformationComponent_SapphireDigital,
    DoctorInformationComponent_Kyruus,
    PharmacyInformationComponent,
    UniqueDoseDirective,
    TotalDrugCostComponent,
    UniqueDoseDirective,
    YearlyDrugCostsGraphComponent,
    YearlyDrugCostsTableComponent,
    ToggleRadioComponent,
    PharmacyDetailComponent,
    IndividualMedInfoComponent,
    MemberDrugInformationComponent,
    DoctorDetailComponent,
    AddressFilterPipe
  ],
  imports: [
    CommonModule,
    MaterialGlobalModule,
    FormsModule,
    ReactiveFormsModule,
    NgReduxModule,
    NgReduxFormConnectModule,
    NgReduxFormConnectArrayModule,
    PtlXhrModule,
    SharedComponentsModule,
    ReducersRegistryModule
  ],
  providers: [
    DecimalPipe,
    CurrencyPipe
  ],
  exports: [
    MedicationInformationComponent,
    DoctorInformationComponent_Wrapper,
    DoctorInformationComponent_SapphireDigital,
    DoctorInformationComponent_Kyruus,
    PharmacyInformationComponent,
    PharmacyDetailComponent,
    DoctorDetailComponent,
    TotalDrugCostComponent,
    YearlyDrugCostsGraphComponent,
    YearlyDrugCostsTableComponent,
    ToggleRadioComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MedicalInformationModule implements DoBootstrap {

  constructor(
    private injector: Injector,
    private stateModuleReadyService: StateModuleReadyService
  ) {
    // console.log("MedicalInformationModule - constructor");
    this.stateModuleReadyService.ready$.subscribe((isReady: boolean) => {
      if (isReady) {
        this.createElementIfDoesNotExist('sxe-medication-information', MedicationInformationComponent);
        this.createElementIfDoesNotExist('sxe-doctor-information', DoctorInformationComponent_Wrapper);
        this.createElementIfDoesNotExist('sxe-pharmacy-information', PharmacyInformationComponent);
        this.createElementIfDoesNotExist('sxe-member-drug-information', MemberDrugInformationComponent);
        this.createElementIfDoesNotExist('sxe-total-drug-cost', TotalDrugCostComponent);
        this.createElementIfDoesNotExist('sxe-yearly-drug-costs-graph', YearlyDrugCostsGraphComponent);
        this.createElementIfDoesNotExist('sxe-yearly-drug-costs-table', YearlyDrugCostsTableComponent);
        this.createElementIfDoesNotExist('sxe-toggle-radio-component', ToggleRadioComponent);
        this.createElementIfDoesNotExist('sxe-individual-med-info', IndividualMedInfoComponent);
      }
    });

  }

  /** Adding these checks in, as during debugging, sometimes the error of previous definition would be thrown */
  createElementIfDoesNotExist(elementName: string, elementComponent: any) {
    if (!customElements.get(elementName)) {
      const customElement = createCustomElement(elementComponent, { injector: this.injector });
      customElements.define(elementName, customElement);
    }
  }

  // https://github.com/angular/angular/issues/31135
  // Necessary to not get errors associated w/ attachShadow to Angular Element
  ngDoBootstrap() { }
}
